import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {ProtectedResponse} from "../Auth/types";
import {fetchProtected} from "../Auth/auth";

const ProtectedPage: React.FC = () => {
    const [data, setData] = useState<ProtectedResponse | null>(null);
    const [error, setError] = useState<string>('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchProtected()
            .then((response) => setData(response))
            .catch((err) => {
                setError(err.message);
                navigate('/login');
            });
    }, [navigate]);

    if (!data) return <p>Loading...</p>;

    return (
        <div>
            <h2>Protected Page</h2>
            <p>{data.message}</p>
        </div>
    );
};

export default ProtectedPage;